import React from 'react'
import { Alert, type AlertColor, Snackbar } from '@mui/material'

interface ToastWithMessageProps {
  message: string
  severity: AlertColor
  toastOpen: boolean
  setToastOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const ToastWithMessage: React.FC<ToastWithMessageProps> = (props) => {
  const { message, severity, toastOpen, setToastOpen } = props

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={5000}
      open={toastOpen}
      onClose={() => {
        setToastOpen(false)
      }}
    >
      <Alert
        sx={{
          bgcolor: 'background.paper',
          width: 1,
          fontSize: 'medium',
          whiteSpace: 'pre-line',
          '& .MuiAlert-message': {
            width: 'fit-content',
          },
        }}
        variant='outlined'
        onClose={() => {
          setToastOpen(false)
        }}
        severity={severity}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

const MemoizedToastWithMessage = React.memo(ToastWithMessage)

export default MemoizedToastWithMessage
